module.exports = __webpack_public_path__ + "static/img/morteisen.676410a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/morteisen.png
// module id = 2/Ke
// module chunks = 0